import React, { useCallback } from "react";
import Button from "../../../components/Common/Button/Button";
import MainLayout from "../../../components/Common/MainLayout/MainLayout";
import Dropdown from "../../../components/Common/ReactForm/Dropdown/Dropdown";
import classes from "./AccessReportPage.module.scss";
import {
  accessReport,
  accessReportAAD,
} from "../../../utils/mainTabs/reports/accessReport";
import { useNavigate, useOutletContext } from "react-router";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import {
  getAADApplicationReportActionHandler,
  getAADUserAccessDetailReportCSVActionHandler,
  getAADUserAccessDetailsReportActionHandler,
  getAccessDetailedReportCSVActionHandler,
  getAccessReportActionHanlder,
  getAccessReportCSVActionHandler,
  getApplicationAccessUserDetailsActionHandler,
  getTenantUsersActionHandler,
  getUserGroupActionhandler,
  getAADApplicationReportCSVHandler,
} from "../../../store/actions/actionHandlers/reportActionHandler";
import { useState } from "react";
import { useEffect } from "react";
import { useFetchData } from "../../../hooks/useFetchData";
import Input from "../../../components/Common/ReactForm/Input/Input";
import DataTable from "../../../components/Common/DataTable/DataTable";
import {
  aadAccessModalReport,
  accessModalReport,
} from "../../../utils/mainTabs/reports/accessModalReport";
import Modal from "../../../components/Common/Modal/Modal";
import moment from "moment";
import { setErrorAction } from "../../../store/actions/actionCreators/errorActionCreator";
import { errorTypes } from "../../../utils/errorTypes";
import { TimeZoneOptions } from "../ReportData/TimeZone";
import { FormattedMessage, injectIntl } from "react-intl";
import { FormProvider, useForm } from "react-hook-form";
import InputHookForm from "../../../components/Common/Input/Input";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { dateFormatyyyymmdd } from "../../SocialPage/PollManagement/DistributePoll/DistributePollForm/DistributePollForm";
import { differenceInDays } from "date-fns";
import Tooltip from "../../../components/Common/ToolTip/Tooltip";
import { apiConstants } from "../../../utils/apiConstants";
import getAADApplicationReport from "../../../api/reports/accessReport/getAADApplicationReport";

export const accessReportSchema = yup.object().shape({
  userGroup: yup
    .array(
      yup.object().shape({
        Name: yup.string(),
        TypeId: yup.number(),
      })
    )
    .max(5, "Maximum 5 User are allowed"),
});

const AccessReportPage = ({ intl }) => {
  const navigate = useNavigate();
  const { navLinks, columns } = accessReport;
  const { aadColumns } = accessReportAAD;
  const { tenantName } = useOutletContext();
  const { columns: modalColumns } = accessModalReport;
  const { aadAccessModalReportColumns } = aadAccessModalReport;
  const tenantType = localStorage.getItem("SecurityProviderName").toLowerCase();
  const reportState = useSelector((state) => state.reportReducer);
  const dispatch = useDispatch();

  const pageNumber = 1;
  const pageSize = 20;
  const { SUCCESS, FAIL, WARN } = errorTypes;
  const { userGroup, className, tenantUsers } = reportState;

  const [reportMode, setReportMode] = useState("View");
  const [fromDate, setFromDate] = useState("none");
  const [selectedUserGroup, setSelectedUserGroup] = useState([]);
  const [selectedClassName, setSelectedClassName] = useState([]);
  const [selectedUser, setSelectedUser] = useState();
  const [toDate, setToDate] = useState("none");
  const [timeZone, setTimeZone] = useState("UTC");
  const [selectedUserGroupId, setSelectedUserGroupId] = useState("");
  const [selectedUserId, setSelectedUserId] = useState(0);
  const [defaultGroup, setDefaultGroup] = useState("");
  const [Id, setId] = useState(0);
  const [booleanSelectUser, setBooleanSelectUser] = useState(false);
  const [toMinDate, setToMinDate] = useState(null);
  const [fromMaxDate, setFromMaxDate] = useState(
    dateFormatyyyymmdd(new Date())
  );
  const [fromMinDate, setFromMinDate] = useState(null);
  const [toMaxDate, setToMaxDate] = useState(dateFormatyyyymmdd(new Date()));
  const [aadAccessReportData, setAadAccessReportData] = useState([]);
  const [aadUserAccessDetailsReport, setAadUserAccessDetailsReport] = useState(
    []
  );
  const [userGroupOptions, setUserGroupOptions] = useState([]);
  const [classNameOptions, setClassNameOptions] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [chkDiffFromDate, setchkDiffFromDate] = useState("");
  const [chkToDate, setchkToDate] = useState("");
  const [fromDateValue, setFromDateValue] = useState("");
  const [toDateValue, setToDateValue] = useState("");
  const [tableColumns, setTableColumns] = useState([]);
  const [modalTableColumns, setModalTableColumns] = useState([]);
  const [isClicked, setIsClicked] = useState(false);
  const [userGroupList, setUserGroupList] = useState([]);
  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(accessReportSchema),
  });
  const {
    formState: { errors },
    reset,
    getValues,
    watch,
  } = methods;
  const [accessReportTenantUser, setAccessReportTenantUser] = useState([]);
  const watchuserGroup = watch("userGroup");
  const [selectedUserData, setSelectedUserData] = useState("");
  const [searchedWithStartDateAndEndDate, setSearchedWithStartDateAndEndDate] =
    useState(false);

  const {
    data,
    setData,
    updatedData,
    setUpdatedData,
    totalRows,
    handleCurrentPage,
    handleSearchQuery,
    loading,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setAccessReport,
      setTempAccessReport,
      setTotalRows
    ) =>
      getAccessReportActionHanlder(
        "",
        pageNumber,
        pageSize,
        setAccessReport,
        setTempAccessReport,
        setTotalRows,
        fromDate,
        toDate,
        selectedUserId,
        selectedUserGroupId?.length > 0
          ? selectedUserGroupId.toString()
          : defaultGroup.toString(),
        timeZone,
        reportMode
      ),
    pageSize
  );
  const {
    data: modalData,
    setData: setModalData,
    updatedData: updatedModalData,
    setUpdatedData: setModalUpdatedData,
    totalRows: setModalTotalRows,
    handleCurrentPage: handlerModalCurrentPage,
    handleSearchQuery: handleModalSearchQuery,
    loading: loadingModal,
  } = useFetchData(
    (
      searchText,
      pageNumber,
      pageSize,
      setDrillDownQuizReport,
      setTempDrillDownQuizReport,
      setTotalRows
    ) =>
      getApplicationAccessUserDetailsActionHandler(
        searchText,
        pageNumber,
        pageSize,
        setDrillDownQuizReport,
        setTempDrillDownQuizReport,
        setTotalRows,
        Id,
        fromDate,
        toDate,
        timeZone,
        reportMode
      ),
    pageSize
  );

  useEffect(() => {
    if (tenantUsers.length == 0 || userGroup.length == 0) {
      dispatch(getTenantUsersActionHandler());
      dispatch(getUserGroupActionhandler());
    }
    if (selectedUser) {
      setSelectedUserId(parseInt(selectedUser));
    }
  }, [dispatch, selectedUser]);

  const onFromDateChange = (date) => {
    setFromDateValue(date.target.value);
    if (date.target.value) {
      setToMinDate(date.target.value);
      const newDate = moment(date.target.value).format("DD/MM/YYYY");
      setFromDate(newDate);
    } else setFromDate("none");
    const chkDiff = moment(date.target.value).format("YYYY-MM-DD");
    setchkDiffFromDate(chkDiff);
  };

  const onToDateChange = (date) => {
    setToDateValue(date.target.value);
    if (date.target.value) {
      setFromMaxDate(date.target.value);
      const newDate = moment(date.target.value).format("DD/MM/YYYY");
      setToDate(newDate);
    } else setToDate("none");
    const chkDiff = moment(date.target.value).format("YYYY-MM-DD");
    setchkToDate(chkDiff);
  };

  const handleUserPopUp = useCallback((Id) => {
    setId(Id);
    handleModalSearchQuery("");
  }, []);

  const handleAADUserPopUp = useCallback((row) => {
    setSelectedUserData(row);
  }, []);

  useEffect(() => {
    if (selectedUserData?.LoginId) {
      setAadUserAccessDetailsReport([]);
      dispatch(
        getAADUserAccessDetailsReportActionHandler(
          selectedUserData?.LoginId,
          searchedWithStartDateAndEndDate ? fromDate : "none",
          searchedWithStartDateAndEndDate ? toDate : "none",
          setAadUserAccessDetailsReport
        )
      );
    }
  }, [selectedUserData?.LoginId]);

  const handleUserClassData = () => {
    handleUserPopUp(0);
    handleAADUserPopUp({ LoginId: 0 });
  };

  useEffect(() => {
    let newTableColumns;
    if (tenantType === "aad")
      newTableColumns = aadColumns(navigate, handleAADUserPopUp);
    else newTableColumns = columns(navigate, handleUserPopUp);
    setTableColumns(newTableColumns);
  }, [columns, navigate, handleUserPopUp, handleAADUserPopUp]);

  useEffect(() => {
    let newTableColumns;
    if (tenantType === "aad") newTableColumns = aadAccessModalReportColumns();
    else newTableColumns = modalColumns(navigate);
    setModalTableColumns(newTableColumns);
  }, [modalColumns, navigate]);

  useEffect(() => {
    const userGroupOption = userGroup?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    const classNameOption = className?.map((d) => ({
      label: d.Name,
      value: d.TypeId,
    }));
    const userOption = tenantUsers?.map((d) => ({
      label: d.FirstName + " " + d.LastName,
      value: d.Id,
    }));

    setDefaultGroup(userGroup.map((e) => e.Name));
    setUserOptions(userOption);
    setUserGroupOptions(userGroupOption);
    setClassNameOptions(classNameOption);
  }, [userGroup, className, tenantUsers]);

  const onUserGroupSelected = (selected) => {
    setSelectedUserGroup(selected);
  };

  const handleReset = () => {
    setSelectedUser();
    setTimeZone("UTC");
    setSelectedUserGroup([]);
    setUpdatedUserGroups(userGroup);
    setSelectedUserGroup([]);
    setSelectedUserGroupId([]);
    reset();
    setFromDateValue("");
    setToDateValue("");
    setFromDate("none");
    setFromMaxDate("none");
    setToMaxDate("none");
    setToMinDate("none");
    setSelectedUserGroupId(userGroup.map((e) => e.Name));
    setIsClicked(false);
    setToDate("none");
    setSelectedUserId(0);
    // handleSearchQuery("")
  };
  const [aadloader, setAADLoader] = useState(false);
  const onFilterSearch = () => {
    const diff = differenceInDays(chkDiffFromDate, chkToDate);
    const dateDiffChecker = Math.abs(diff);
    if (dateDiffChecker > 90) {
      dispatch(
        setErrorAction("WARN", "Can select maximum duration of 90 days only")
      );
      // setAADLoader(false)
    } else {
      if (tenantType === "aad") {
        setAADLoader(true);
        setAadAccessReportData([]);
        const data = {
          Usergroups:
            selectedUserGroupId?.length > 0
              ? selectedUserGroupId.toString()
              : defaultGroup.toString(),
          endDate: toDate,
          startDate: fromDate,
          userId: selectedUserId,
        };
        if (fromDate || toDate) setSearchedWithStartDateAndEndDate(true);
        else setSearchedWithStartDateAndEndDate(false);
        dispatch(
          getAADApplicationReportActionHandler(data, setAadAccessReportData)
        )
          .then(() => {
            setAADLoader(false);
          })
          .catch((err) => {
            console.log(err);
          })
          .finally(() => {
            setAADLoader(false);
          });
      } else handleSearchQuery("");
      setIsClicked(true);
    }
    // setAADLoader(false)
  };

  const handleClick = () => {
    const userGroups =
      selectedUserGroup.length > 0
        ? selectedUserGroup.map((userGrp) => {
            return userGrp?.label || userGrp?.Name;
          })
        : userGroupOptions.map((userGrp) => {
            return userGrp?.label || userGrp?.Name;
          });
    // const url =
    // `https://dev1services.shotclasses.com//api/v1/AADAccessReport/GetAADApplicationAccessReport?startDate=${fromDate}&endDate=${toDate}&userId=${selectedUser?selectedUser:0}&userGroups=${userGroups}`;
    const url = `${
      apiConstants.REPORT.GET_AAD_APPLICATION_ACCESS_REPORT
    }?startDate=${fromDate}&endDate=${toDate}&userId=${
      selectedUser ? selectedUser : 0
    }&userGroups=${userGroups}`;
    const encodedUrl =
      encodeURIComponent(url) +
      "&template=" +
      "ApplicationAccessReport" +
      "&isAADTenant=" +
      true;
    if (tenantType == "aad") {
      dispatch(
        getAADApplicationReportCSVHandler(
          selectedUser,
          userGroups,
          fromDate,
          toDate
        )
      );
    } else {
      dispatch(
        getAccessReportCSVActionHandler(
          selectedUser,
          userGroups,
          timeZone,
          fromDate,
          toDate
        )
      );
    }
  };

  // {"$$hashKey":"object:354"}
  const handleModalClick = () => {
    const userGroups = userGroupOptions.map((userGrp) => {
      return userGrp?.label;
    });
    const userName = localStorage.getItem("userName");
    const modelStringObj = {
      LoginId: selectedUserData?.LoginId,
      Usergroups: selectedUserData?.UserGroups?.split("|")
        ?.slice(1)
        ?.join("| "),
      Id: selectedUserData?.Id,
      UserName: tenantType === "aad" && selectedUserData?.UserName,
      EmailId: tenantType === "aad" && selectedUserData?.EmailId,
    };
    // const dataObj = {
    //   template: "ApplicationAccessUserLoginDetails",
    //   isAADTenant: tenantType === "aad" && true,
    //   modelString: modelStringObj,
    // };
    const abc = modelStringObj.toString();
    const url = `${apiConstants?.BASE_URL_1}/api/v1/AADAccessReport/GetAADUserAccessDetailsReportCSV?startDate=${fromDate}&endDate=${toDate}&loginId=${userName}`;
    const encodeUrl =
      encodeURIComponent(url) +
      "&template=" +
      "ApplicationAccessUserLoginDetails" +
      "&isAADTenant=" +
      true +
      "&modelString=" +
      JSON.stringify(modelStringObj);
    const tenantName = localStorage.getItem("tenantName");

    if (tenantType === "aad") {
      dispatch(getAADUserAccessDetailReportCSVActionHandler(encodeUrl));
    } else {
      dispatch(
        getAccessDetailedReportCSVActionHandler(
          Id,
          userGroups,
          timeZone,
          fromDate,
          toDate
        )
      );
    }
  };

  const dateDiff = (start, end) => {
    var a = moment(start, "MM/DD/YYYY");
    var b = moment(end, "MM/DD/YYYY");
    return b.diff(a, "days");
  };

  let setUpdatedUserGroups = useCallback(
    (userGroup) => {
      if (userGroup?.length > 0) {
        let updatedUserGroup = userGroup.map((classes) => {
          return { ...classes, isVisible: true };
        });
        setUserGroupList(updatedUserGroup);
        setSelectedUserGroup(userGroup);
      }
    },
    [userGroup, userGroupList]
  );

  useEffect(() => {
    setUpdatedUserGroups(userGroup);
  }, [dispatch, userGroup]);

  useEffect(() => {
    if (userGroupList.length > 0) {
      const filtered = userGroupList.filter((item) => {
        return item.checked === true;
      });
      if (filtered.length > 0) {
        setBooleanSelectUser(true);
        let updateFilteredResult = filtered.map((item) => {
          return { label: item.Name, value: item.TypeId };
        });
        setSelectedUserGroup(updateFilteredResult);
        setSelectedUserGroupId(updateFilteredResult[0]?.label);
      } else {
        setBooleanSelectUser(false);
        setSelectedUserGroupId([]);
      }
    }
  }, [userGroupList]);

  useEffect(() => {
    if (selectedUserGroup?.length > 0) {
      const groupValue = [];
      selectedUserGroup?.map((e) => groupValue.push(e.Name || e.label));
      setSelectedUserGroupId(groupValue);
    }
  }, [selectedUserGroup, userGroup, setSelectedUserGroupId]);

  useEffect(() => {
    if (tenantUsers?.length > 0) {
      const updatedTrainingTypes = tenantUsers?.map((users) => {
        return {
          ...users,
          isVisible: true,
          fullName: users?.FirstName + " " + users?.LastName,
        };
      });
      setAccessReportTenantUser(updatedTrainingTypes);
    }
  }, [tenantUsers, setAccessReportTenantUser]);

  const handleTenantUsers = (e) => {
    const detailsData = getValues();
    setSelectedUser(detailsData.tenantUserName[0].Id);
  };
  return (
    <>
      <MainLayout navLinks={navLinks(navigate, tenantName)}>
        <div
          className={classes.reportFilter_Main}
          style={{ position: "relative", zIndex: "2" }}
        >
          <div className={classes.reportFilter_userCLass}>
            <Input
              label={"From Date"}
              type={"date"}
              // isFromDate
              // isRequired
              width="33.33"
              value={fromDateValue}
              onChange={onFromDateChange}
              min={fromMinDate}
              max={fromMaxDate}
            />
            <Input
              label={"To Date"}
              type={"date"}
              width="33.33"
              value={toDateValue}
              min={toMinDate}
              max={toMaxDate}
              // isRequired
              isLimit
              maxSelected={90}
              validationLabel="Days"
              onChange={onToDateChange}
            />
            {/* <Dropdown
              isMulti
              // isRequired
              name={"userGroup"}
              label={"Users Group"}
              isLimit
              width="33.33"
              defaultValue={selectedUserGroup}
              placeholder={intl.formatMessage({
                id: `SELECT_USER_GROUP`,
              })}
              options={userGroupOptions}
              onChange={onUserGroupSelected}
              maxSelected={5}
              isDisabled={selectedUser?.length > 0}
              validationLabel="Groups"
              selectedValue={selectedUserGroup}
            /> */}
            {/* <FormProvider {...methods}>
             
            </FormProvider> */}
            <Dropdown
              // isRequired
              name={"timeZone"}
              label={"Time Zone"}
              defaultValue={timeZone}
              placeholder="Time Zone "
              width="33.3"
              options={TimeZoneOptions}
              onChange={(e) => setTimeZone(e.target.value)}
              // maxSelected={1}
              validationLabel="User"
              selectedValue={timeZone}
              // isInputDisabled={selectedUserGroup?.length > 0}
            />
          </div>
          <div className={classes.reportFilter_userCLass}>
            <FormProvider {...methods}>
              <InputHookForm
                label={"Users Group"}
                name="userGroup"
                // labelColor="light"
                type="noSearchTags"
                fieldName={"Name"}
                fieldValue="TypeId"
                placeholder={intl.formatMessage({
                  id: `SELECT_USER_GROUP`,
                })}
                labelMsg="(Max: 5 Groups)"
                height="3.9"
                width="33.33"
                labelColor={"#404040"}
                searchable={true}
                id={"TypeId"}
                searchTagsList={userGroupList}
                handleTagList={(tagsList) => {
                  setUserGroupList(tagsList);
                }}
                disabled={selectedUser ? true : false}
                error={errors?.userGroup?.message}
              />
              <InputHookForm
                label={<FormattedMessage id="SELECT_USER" />}
                labelColor="dark"
                name="tenantUserName"
                fieldName={"fullName"}
                fieldValue="Id"
                type="noSearchTags"
                tagType="single"
                buttonLabel={intl.formatMessage({
                  id: `SELECT_USER`,
                })}
                placeholder={intl.formatMessage({
                  id: `SELECT_USER`,
                })}
                searchTagsList={accessReportTenantUser}
                handleTagList={(tagsList) => {
                  setAccessReportTenantUser(tagsList);
                }}
                id={"Id"}
                height="4"
                searchable={true}
                disabled={booleanSelectUser ? true : false}
                isTagCheckBoxVisible={false}
                addedTagsVisible={false}
                onChange={handleTenantUsers}
                width={"33.33"}
              />
            </FormProvider>

            <div className={classes.searchResetButton}>
              <span
                style={{
                  textDecoration: "underline",
                  color: "#0051BC",
                  cursor: "pointer",
                  paddingTop: "12px",
                }}
                onClick={handleReset}
              >
                <FormattedMessage id="Report_Reset_btn" />
              </span>
              <Button
                label={<FormattedMessage id="P_Search" />}
                dark
                small
                className={classes.searchButton}
                onClick={onFilterSearch}
                disabled={watchuserGroup?.length > 5 ? true : false}
              />
            </div>
          </div>
          <div className={classes.searchResetButton}>
            {/* <span
              style={{
                textDecoration: "underline",
                color: "#0051BC",
                cursor: "pointer",
                paddingTop: "12px",
              }}
              onClick={handleReset}
            >
              Reset
            </span>
            <Button
              label={<FormattedMessage id="P_Search" />}
              dark
              small
              className={classes.searchButton}
              onClick={onFilterSearch}
            /> */}
          </div>
        </div>
      </MainLayout>
      {isClicked && (
        <div className={classes.tabularDataTable}>
          <DataTable
            columns={tableColumns}
            defaultData={tenantType === "aad" ? aadAccessReportData : data}
            setDefaultData={
              tenantType === "aad" ? setAadAccessReportData : setData
            }
            data={tenantType === "aad" ? aadAccessReportData : updatedData}
            setData={
              tenantType === "aad" ? setAadAccessReportData : setUpdatedData
            }
            totalRows={
              tenantType === "aad" ? aadAccessReportData?.length : totalRows
            }
            uniqueFieldName={"Id"}
            onDownload={() => handleClick()}
            downloadable
            fetchMoreData={handleCurrentPage}
            loading={tenantType === "aad" ? aadloader : loading}
          />
          <Modal
            handleSubmit={handleUserClassData}
            isOpen={tenantType === "aad" ? selectedUserData?.LoginId : Id}
            heading={"Access Report Details"}
            toggle={() => {
              if (tenantType === "aad") handleAADUserPopUp();
              else handleUserPopUp();
            }}
            width={"100"}
          >
            <div className={classes.classNameHeading}>
              <div className={classes.mainHeadingModal}>
                <div>
                  <p className={classes.fieldName}>
                    <FormattedMessage id="USER" /> :
                  </p>
                  <div>
                    {tenantType === "aad"
                      ? selectedUserData?.UserName
                      : setModalTotalRows?.UserName}
                  </div>
                </div>
                <div>
                  <p className={classes.fieldName}>
                    <FormattedMessage id="USERMANAGE_EMAILID" />
                  </p>
                  <div>
                    {tenantType === "aad"
                      ? selectedUserData?.EmailId
                      : setModalTotalRows?.EmailId}
                  </div>
                </div>
                <div>
                  <p className={classes.fieldName}>
                    <FormattedMessage id="REPORT_USERGRP_TXT" />
                  </p>
                  <div>
                    {tenantType === "aad" ? (
                      selectedUserData?.UserGroups?.split("|")
                        ?.slice(1)
                        ?.join("| ").length < 25 ? (
                        selectedUserData?.UserGroups?.split("|")
                          ?.slice(1)
                          ?.join("| ")
                      ) : (
                        <Tooltip
                          content={selectedUserData?.UserGroups?.split("|")
                            ?.slice(1)
                            ?.join("| ")}
                        >
                          {selectedUserData?.UserGroups?.split("|")
                            ?.slice(1)
                            ?.join("| ")
                            ?.slice(0, 24) + "..."}
                        </Tooltip>
                      )
                    ) : (
                      setModalTotalRows?.UserGroupName?.slice(1)
                    )}
                  </div>
                </div>
                {tenantType !== "aad" && (
                  <div>
                    <p className={classes.fieldName}>
                      <FormattedMessage id="NUMBER_OF_LOGINS" />
                    </p>
                    <div>{setModalTotalRows?.NoOfAttempts}</div>
                  </div>
                )}
              </div>
            </div>

            <div>
              <DataTable
                columns={modalTableColumns}
                defaultData={
                  tenantType === "aad"
                    ? aadUserAccessDetailsReport.LoginDate
                    : modalData
                }
                setDefaultData={
                  tenantType === "aad"
                    ? setAadUserAccessDetailsReport
                    : setModalData
                }
                data={
                  tenantType === "aad"
                    ? aadUserAccessDetailsReport.LoginDate
                    : updatedModalData
                }
                setData={
                  tenantType === "aad"
                    ? setAadUserAccessDetailsReport
                    : setModalUpdatedData
                }
                totalRows={
                  tenantType === "aad"
                    ? aadUserAccessDetailsReport?.LoginDate?.length
                    : setModalTotalRows?.NoOfAttempts
                }
                uniqueFieldName={"LoginId"}
                onDownload={handleModalClick}
                fetchMoreData={handlerModalCurrentPage}
                downloadable
                loading={loadingModal}
              />
            </div>
          </Modal>
        </div>
      )}
    </>
  );
};

export default injectIntl(AccessReportPage);
